<template>
    <div class="">
        <el-button @click.native.prevent="getExportCatalogue" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="Téléchargement en cours..." type="warning" size="small" class="btnGenerateCsv">
            <i class="fas fa-file-csv iconOperationCsv"> Générer l'export catalogue .XLSX</i>
        </el-button>
    </div>
</template>

<script>
var moment = require('moment');
import script from '../../../script/script.js';
import scriptCatalogue from '../../../script/script_catalogue';
export default {
	data () {
		return {
            fullscreenLoading:false,
		}
	},
	methods: {
        getExportCatalogue: scriptCatalogue.getExportCatalogue,
    },
	computed:{
	},
	mounted: function(){
	}
}
</script>

<style>
.btnGenerateCsv{
	margin-left: .5em;
}
</style>